import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Button, DropButton } from 'grommet';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { DocumentUpload, DocumentImage, Download, Notes as NotesIcon, Task } from 'grommet-icons';
import { Adobeaudition } from '@styled-icons/simple-icons/Adobeaudition';
import useQuery from 'granite-admin/utils/useQuery';
import Tooltip from 'granite-admin/core/components/Tooltip';
import Divider from 'granite-admin/core/components/Divider';
import { getGrandEmitter } from 'granite-admin/utils/grandEmitter';
const size = 18;

// const hasNumber = str => {
//   return /\d/.test(str);
// };

// eslint-disable-next-line no-extend-native
String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};
const renderLabel = (label, params, query, isLastBreadcrumb) => {
  return label.includes(':') && !isLastBreadcrumb && label.replace(':', '') in params ? params[`${label.replace(':', '')}`].capitalize() : label.includes(':') && isLastBreadcrumb && label.replace(':', '') in params // this was failed in case of tab UI
  ? query.h ? query.h.capitalize() : params[`${label.replace(':', '')}`].capitalize() : label === 'tab' // so added this to handle tab
  ? query?.h?.capitalize() ?? label : label;
};
const TextItem = styled(Text)`
  font-size: ${size}px;
  line-height: ${size}px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
const StyledButton = styled(Button)`
  background: ${({
  theme,
  accentTypePlain
}) => accentTypePlain ? '' : theme.global.colors['action-buttons-background']};
  border-radius: ${({
  theme
}) => theme.global.borderSize.medium};
  color: ${({
  theme,
  accentTypePlain
}) => accentTypePlain ? 'transparent' : theme.global.colors['action-buttons-background']};
  border: none;
  &:hover {
    background: ${({
  theme,
  accentTypePlain
}) => accentTypePlain ? theme.global.colors['action-buttons-background'] : ''};
    box-shadow: ${({
  theme,
  accentTypePlain
}) => accentTypePlain ? 'none' : `0px 0px 0px 2px ${theme.global.colors['action-buttons-background']}`};
  }
`;
const PageHeading = ({
  heading,
  breadcrumbPath,
  permissions,
  setShowActiveTab
}) => {
  const grandEmitter = useMemo(() => getGrandEmitter(), []);
  let history = useHistory();
  const params = useParams();
  const {
    query
  } = useQuery();
  const haveExportPermission = useMemo(() => {
    return permissions?.find(i => i.type === 'table_export');
  }, [permissions]);
  const haveImportPermission = useMemo(() => {
    return permissions?.find(i => i.type === 'table_import');
  }, [permissions]);
  const actionItems = useMemo(() => {
    const actions = {};
    if (permissions) permissions.forEach(i => {
      if (['audits', 'notes', 'documents', 'tasks'].indexOf(i.type) > -1) actions[i.type] = {
        ...i.extra_data,
        icon: i.icon
      };
    });
    return actions;
  }, [permissions]);
  const handleActiveTabsChange = type => {
    grandEmitter.emit('SET_ACTIVE_TAB', type);
    setShowActiveTab(type);
  };
  return /*#__PURE__*/React.createElement(Box, {
    flex: {
      grow: 1
    },
    pad: {
      horizontal: 'xsmall'
    },
    margin: {
      top: 'xsmall'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    justify: "between",
    wrap: true,
    margin: {
      horizontal: 'xsmall'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    margin: {
      bottom: '0.25rem'
    },
    justify: heading?.subTitle ? undefined : 'center',
    direction: "column",
    gap: "xxsmall"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    gap: "xxsmall"
  }, breadcrumbPath.map((i, ind) => /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    key: ind
  }, /*#__PURE__*/React.createElement(TextItem, {
    weight: "bold",
    onClick: () => i.path && history.push(i.path),
    margin: {
      right: 'small'
    }
  }, renderLabel(i.label, params, query, ind === breadcrumbPath.length - 1)), ind !== breadcrumbPath.length - 1 && /*#__PURE__*/React.createElement(TextItem, {
    size: "xlarge",
    weight: "bold",
    color: "#8c8c89",
    margin: {
      right: 'xsmall'
    }
  }, "/")))), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: 400,
    margin: {
      left: 'xxsmall'
    }
  }, heading?.subTitle)), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    gap: "small",
    justify: "end"
  }, haveExportPermission && /*#__PURE__*/React.createElement(Tooltip, {
    content: "Export",
    align: "bottom"
  }, /*#__PURE__*/React.createElement(DropButton, {
    as: "div",
    dropAlign: {
      top: 'bottom',
      right: 'right'
    },
    dropContent: /*#__PURE__*/React.createElement(Box, {
      direction: "column",
      gap: "small",
      pad: "xsmall"
    }, /*#__PURE__*/React.createElement(Text, {
      margin: {
        top: 'small',
        horizontal: 'small'
      }
    }, "Choose Export Format"), /*#__PURE__*/React.createElement(Divider, {
      style: {
        width: 'auto',
        minWidth: 'auto'
      },
      color: "#c6c6c6",
      background: {
        color: 'border',
        opacity: 'medium'
      }
    }), haveExportPermission?.extra_data?.types.map(i => /*#__PURE__*/React.createElement(Button, {
      key: i,
      as: "div",
      label: i.toUpperCase(),
      onClick: () => {
        const name = haveExportPermission?.extra_data?.table_name;
        const sync = haveExportPermission?.extra_data?.sync;
        grandEmitter.emit(`EXPORT`, {
          type: i.toLowerCase(),
          name,
          sync
        });
        console.log(i.toLowerCase());
      },
      style: {
        background: 'transparent',
        color: '#fbab31',
        textAlign: 'center'
      },
      primary: true,
      border: {
        color: 'brand',
        size: 'medium',
        style: 'solid',
        side: 'all'
      }
    })))
  }, /*#__PURE__*/React.createElement(Button, {
    primary: true,
    color: "brand",
    plain: false,
    icon: /*#__PURE__*/React.createElement(Download, {
      size: `${size}px`,
      color: "white"
    })
  }))), haveImportPermission && /*#__PURE__*/React.createElement(Tooltip, {
    content: "Bulk Import",
    align: "bottom"
  }, /*#__PURE__*/React.createElement(Button, {
    plain: false,
    primary: true,
    icon: /*#__PURE__*/React.createElement(DocumentUpload, {
      size: `${size}px`,
      color: "white"
    }),
    onClick: () => {
      if (haveImportPermission?.url) history.push(haveImportPermission?.url);else console.error('URL not found');
    }
  })), actionItems['tasks'] && params[actionItems['tasks']?.objectId?.slice(1)] !== 'add' && (actionItems['tasks'].icon ? /*#__PURE__*/React.createElement(StyledButton, {
    accentTypePlain: actionItems['tasks'].accentType === 'plain',
    focusIndicator: false,
    plain: actionItems['tasks'].plain === 'true' ? true : false,
    icon: /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: actionItems['tasks'].icon
      }
    }),
    onClick: () => handleActiveTabsChange('tasks'),
    tip: "Tasks"
  }) : /*#__PURE__*/React.createElement(Button, {
    primary: true,
    color: "brand",
    plain: false,
    icon: /*#__PURE__*/React.createElement(Task, {
      size: `${size}px`,
      color: "white"
    }),
    onClick: () => handleActiveTabsChange('tasks'),
    tip: "Tasks"
  })), actionItems['documents'] && params[actionItems['documents']?.objectId?.slice(1)] !== 'add' && /*#__PURE__*/React.createElement(Tooltip, {
    content: "Documents",
    align: "bottom"
  }, actionItems['documents'].icon ? /*#__PURE__*/React.createElement(StyledButton, {
    accentTypePlain: actionItems['documents'].accentType === 'plain',
    focusIndicator: false,
    plain: false,
    icon: /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: actionItems['documents'].icon
      }
    }),
    onClick: () => handleActiveTabsChange('documents')
  }) : /*#__PURE__*/React.createElement(Button, {
    primary: true,
    color: "brand",
    plain: false,
    icon: /*#__PURE__*/React.createElement(DocumentImage, {
      size: `${size}px`,
      color: "white"
    }),
    onClick: () => handleActiveTabsChange('documents')
  })), actionItems['notes'] && params[actionItems['notes']?.objectId?.slice(1)] !== 'add' && /*#__PURE__*/React.createElement(Tooltip, {
    content: "Notes",
    align: "bottom"
  }, actionItems['notes'].icon ? /*#__PURE__*/React.createElement(StyledButton, {
    accentTypePlain: actionItems['notes'].accentType === 'plain',
    focusIndicator: false,
    plain: false,
    icon: /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: actionItems['notes'].icon
      }
    }),
    onClick: () => handleActiveTabsChange('notes')
  }) : /*#__PURE__*/React.createElement(Button, {
    primary: true,
    color: "brand",
    plain: false,
    icon: /*#__PURE__*/React.createElement(NotesIcon, {
      size: `${size}px`,
      color: "white"
    }),
    onClick: () => handleActiveTabsChange('notes')
  })), actionItems['audits'] && params[actionItems['audits']?.objectId?.slice(1)] !== 'add' && (actionItems['audits'].icon ? /*#__PURE__*/React.createElement(StyledButton, {
    accentTypePlain: actionItems['audits'].accentType === 'plain',
    focusIndicator: false,
    plain: actionItems['audits'].plain === 'true' ? true : false,
    icon: /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: actionItems['audits'].icon
      }
    }),
    onClick: () => handleActiveTabsChange('audits'),
    tip: "Audits"
  }) : /*#__PURE__*/React.createElement(Button, {
    primary: true,
    color: "brand",
    plain: false,
    icon: /*#__PURE__*/React.createElement(Adobeaudition, {
      size: `${size}px`,
      color: "white"
    }),
    onClick: () => handleActiveTabsChange('audits'),
    tip: "Audits"
  })), permissions.map(item => {
    if (item.type === 'navigation_button') {
      return /*#__PURE__*/React.createElement(Button, {
        key: item.pk,
        plain: item.extra_data?.plain === 'true' ? true : false,
        label: item.name !== "''" ? item.name : null,
        primary: item.extra_data?.iconOnly === 'true' ? false : true,
        color: "brand",
        onClick: () => history.push(item.url),
        style: item.extra_data?.style,
        reverse: item.extra_data?.reverse,
        icon: item.icon && typeof item.icon === 'string' ? /*#__PURE__*/React.createElement("span", {
          style: item.extra_data?.iconOnly === 'true' ? {} : {
            display: 'flex',
            maxHeight: '16px',
            maxWidth: '16px'
          },
          dangerouslySetInnerHTML: {
            __html: item.icon
          }
        }) : item.icon ? item.icon : undefined,
        tip: item?.extra_data?.tip
      });
    } else if (item.type === 'emitter') {
      return /*#__PURE__*/React.createElement(Button, {
        key: item.pk,
        plain: item.extra_data?.plain === 'true' ? true : false,
        title: item.name !== "''" ? item.name : null,
        primary: item.extra_data?.iconOnly === 'true' ? false : true,
        label: item.name !== "''" ? item.name : null,
        size: "small",
        style: item.extra_data?.style,
        reverse: item.extra_data?.reverse,
        icon: item.icon && typeof item.icon === 'string' ? /*#__PURE__*/React.createElement("span", {
          style: item.extra_data?.iconOnly === 'true' ? {} : {
            display: 'flex',
            maxHeight: '16px',
            maxWidth: '16px'
          },
          dangerouslySetInnerHTML: {
            __html: item.icon
          }
        }) : item.icon ? item.icon : undefined,
        tip: item?.extra_data?.tip,
        onClick: () => grandEmitter.emit(item.url, {
          type: item.type?.toLowerCase(),
          extra_data: item.extra_data
        })
      });
    }
    return null;
  }))));
};
PageHeading.defaultProps = {
  breadcrumbPath: [],
  heading: {}
};
PageHeading.propTypes = {
  breadcrumbPath: PropTypes.array,
  heading: PropTypes.object,
  permissions: PropTypes.array
};
export default PageHeading;